import { connect } from 'react-redux';
import { Bookmark, BookmarkBorder } from '@mui/icons-material';

let presentationSequence = 0;
export const PreviewBookmarkButton = ({ preview, saved, dispatch, className = 'previewInfoFooterIconButton', disabled = false }) => (
    <button type='button' className={className} disabled={disabled}
        aria-label={saved ? 'Manage saved highlight' : 'Save highlight'} aria-pressed={saved}
        onClick={() => {
            const audio = document.getElementById('audio');
            const shouldResume = Boolean(audio && audio.src === preview.mp3URL && !audio.paused && !audio.ended);
            dispatch({ type: 'OPEN_SAVED_HIGHLIGHT', payload: { preview, token: ++presentationSequence, shouldResume } });
            if (shouldResume) audio.pause();
        }}>
        {saved ? <Bookmark aria-hidden='true' style={{ fontSize: 20 }} /> : <BookmarkBorder aria-hidden='true' style={{ fontSize: 20 }} />}
    </button>
);
export default connect((state, { preview }) => ({
    saved: Object.prototype.hasOwnProperty.call(state.savedHighlights?.memberships || {}, preview.id),
}))(PreviewBookmarkButton);
